import { DialogComponent, DialogOpenEvent } from '@theme/dialog';

class CartDrawerComponent extends DialogComponent {
  /** @type {number} */
  #summaryThreshold = 0.5;

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener(DialogOpenEvent.eventName, this.#updateStickyState);
    
    // Listen for form submissions on all product forms
    this.#setupFormListeners();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener(DialogOpenEvent.eventName, this.#updateStickyState);
  }

  #setupFormListeners() {
    // Listen for successful cart additions
    document.addEventListener('submit', async (event) => {
      const form = event.target;
      
      // Check if this is a product form
      if (!form || form.getAttribute('action') !== '/cart/add') return;
      
      console.log('🛒 Product form submitted, will update cart after response');
      
      // Wait a bit for the cart to update on the server
      setTimeout(async () => {
        await this.refreshCart();
        
        if (this.hasAttribute('auto-open')) {
          this.showDialog();
        }
      }, 500);
    });
  }

  async refreshCart() {
    console.log('🔄 Refreshing cart drawer...');
    
    const { dialog } = this.refs;
    const cartItemsComponent = dialog?.querySelector('cart-items-component');
    
    if (!cartItemsComponent) {
      console.warn('⚠️ Cart items component not found');
      return;
    }

    const sectionId = cartItemsComponent.dataset.sectionId;
    if (!sectionId) {
      console.warn('⚠️ Section ID not found');
      return;
    }

    try {
      // Fetch fresh cart HTML
      const response = await fetch(`/?section_id=${sectionId}`);
      const html = await response.text();
      
      const parser = new DOMParser();
      const newDoc = parser.parseFromString(html, 'text/html');
      const newCartItems = newDoc.querySelector('cart-items-component');
      
      if (newCartItems) {
        console.log('✅ Updating cart content');
        cartItemsComponent.innerHTML = newCartItems.innerHTML;
        this.#updateStickyState();
        
        // Update cart icon in header
        const newCartIcon = newDoc.querySelector('cart-icon');
        const currentCartIcon = document.querySelector('.header-actions__cart-icon');
        if (newCartIcon && currentCartIcon) {
          currentCartIcon.outerHTML = newCartIcon.outerHTML;
          console.log('✅ Cart icon updated');
        }
      }
    } catch (error) {
      console.error('❌ Failed to refresh cart:', error);
    }
  }

  open() {
    this.showDialog();

    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }

  #updateStickyState() {
    const { dialog } = this.refs;
    if (!dialog) return;

    const content = dialog.querySelector('.cart-drawer__content');
    const summary = dialog.querySelector('.cart-drawer__summary');

    if (!content || !summary) {
      dialog.setAttribute('cart-summary-sticky', 'false');
      return;
    }

    const drawerHeight = dialog.getBoundingClientRect().height;
    const summaryHeight = summary.getBoundingClientRect().height;
    const ratio = summaryHeight / drawerHeight;
    dialog.setAttribute('cart-summary-sticky', ratio > this.#summaryThreshold ? 'false' : 'true');
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}